import ReactDOM from "react-dom";
import React from "react";
import { SearchResultList } from "../../components/SearchResultList/SearchResultList";
import { SearchForm } from "../SearchForm/SearchForm";
import { SearchResultSummary } from "../../components/SearchResultSummary/SearchResultSummary";
import { SearchResultFooter } from "../../components/SearchResultFooter/SearchResultFooter";
import { Alert } from "../../components/Alert/Alert";

import { Analytics } from "../../clients/Analytics";
import { clean, search } from "./actions";

export class SearchPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchQuery: "",
            searchResult: null,
            searchResultRange: { last: 0, length: 0 },
            searchError: null,
            disableForm: false,
        };

        this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
        this.handleLuckyClick = this.handleLuckyClick.bind(this);
        this.handleFooterClick = this.handleFooterClick.bind(this);
    }

    componentDidMount() {
        this.analytics = new Analytics();
    }

    callSubtitleSearch(searchQuery, isAppend) {
        return new Promise((resolve, reject) => {
            let first = isAppend ? this.state.searchResultRange.last + 1 : 0;
            this.setState(clean(isAppend));

            search(searchQuery, first, this.props.pageSize, isAppend, this.state.searchResult)
                .then((state) => {
                    this.setState(state);

                    if (!isAppend) ReactDOM.findDOMNode(this.refs.searchForm.refs.txtSearch).focus();
                })
                .catch((state) => this.setState(state));
        });
    }

    handleSearchSubmit(e) {
        this.callSubtitleSearch(e.searchQuery, false);
    }

    handleLuckyClick(e) {
        this.callSubtitleSearch(e.searchQuery, false).then((apiResult) => {
            if (this.state.searchResult.count > 0) {
                this.analytics.trackEvent({ category: "subs", action: "lucky", label: e.searchQuery });
                window.location = apiResult.data.results[0].downloadUrl;
            }
        });
    }

    handleFooterClick(e) {
        this.callSubtitleSearch(this.state.searchQuery, true);
    }

    render() {
        return (
            <div className="searchPage">
                {/* <SearchForm
                    ref="searchForm"
                    onSearchSubmit={this.handleSearchSubmit}
                    onLuckyClick={this.handleLuckyClick}
                    disabled={this.state.disableForm}
                />
                <Alert error={this.state.searchError} />
                <SearchResultSummary
                    searchResult={this.state.searchResult}
                    searchResultRange={this.state.searchResultRange}
                />
                <SearchResultList searchResult={this.state.searchResult} />
                <SearchResultFooter
                    searchResult={this.state.searchResult}
                    searchResultRange={this.state.searchResultRange}
                    onClick={this.handleFooterClick}
                /> */}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ../containers/SearchPage/SearchPage.jsx